import { styled, Dialog, Button, DialogActions, DialogContent, IconButton, DialogTitle, CircularProgress } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close'

interface SearchingResultDialogProps {
    open: boolean,
    onOpenChange?: Function,
    hostServiceListCount?: number
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
    '& .MuiDialog-paper': {
        width: 'auto',
        maxHeight: '590px',
        maxWidth: '100%'
    }
}));



export const SearchingResultDialog = (props: SearchingResultDialogProps): JSX.Element => {
    const {
        onOpenChange,
        open,
        hostServiceListCount
    } = props

    const handleClose = () => {
            onOpenChange?.(false);
    }

    return (
        <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
        >
            <DialogTitle sx={{ minHeight: '52px', m: 0, p: 2 }} id="customized-dialog-title">

            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent dividers>
                <h2>{hostServiceListCount === undefined ? '' : hostServiceListCount} competitors found</h2>
   
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>
                    Close
                </Button>
            </DialogActions>
        </BootstrapDialog>
    )
}